import { useState } from "react";
import { Menu, X, LogIn, Rocket } from "lucide-react";
import { useNavigate } from "react-router-dom";

const links = [
  { href: "#como-funciona", label: "COMO FUNCIONA" },
  { href: "#funcionalidades", label: "FUNCIONALIDADES" },
  { href: "#precos", label: "PREÇOS" },
  { href: "#faq", label: "DÚVIDAS" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const goLogin = () => navigate("/login");
  const goRegister = () => navigate("/login", { state: { register: true } });

  return (
    <header data-testid="header" className="sticky top-0 inset-x-0 z-50 bg-brutal-cream border-b-[3px] border-brutal-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <a href="#topo" data-testid="header-logo" className="flex items-center gap-2.5 group">
          <div className="relative">
            <img src="/logo-pedefacil.jpg" alt="Pede é Fácil" className="h-11 w-11 border-[2.5px] border-brutal-black shadow-brutal-xs object-cover bg-white group-hover:translate-y-[-2px] group-hover:shadow-brutal-sm transition-all" />
          </div>
          <span className="font-heading text-lg sm:text-xl text-brutal-black uppercase tracking-tight leading-none">
            Pede<span className="text-brutal-pink"> é </span>Fácil
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="font-mono text-[11px] font-bold text-brutal-black hover:text-brutal-pink transition-colors uppercase tracking-wider">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2.5">
          <button data-testid="header-login-btn" onClick={goLogin} className="font-mono text-xs font-bold uppercase tracking-wider text-brutal-black border-[2.5px] border-brutal-black bg-white px-4 py-2.5 shadow-brutal-xs hover:translate-y-[-2px] hover:shadow-brutal-sm active:translate-y-[1px] active:shadow-none transition-all inline-flex items-center gap-1.5">
            <LogIn size={14} strokeWidth={3} />Entrar
          </button>
          <button data-testid="header-register-btn" onClick={goRegister} className="font-mono text-xs font-bold uppercase tracking-wider text-brutal-black border-[2.5px] border-brutal-black bg-brutal-yellow px-4 py-2.5 shadow-brutal-sm hover:translate-y-[-2px] hover:shadow-brutal active:translate-y-[1px] active:shadow-brutal-xs transition-all inline-flex items-center gap-1.5">
            <Rocket size={14} strokeWidth={3} />Criar Conta
          </button>
        </div>

        <button data-testid="header-mobile-menu-btn" className="md:hidden border-[2.5px] border-brutal-black bg-white p-2 shadow-brutal-xs" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={20} strokeWidth={3} /> : <Menu size={20} strokeWidth={3} />}
        </button>
      </div>

      {open && (
        <div data-testid="header-mobile-menu" className="md:hidden bg-brutal-cream border-t-[3px] border-brutal-black px-5 py-5 space-y-3">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block font-mono text-sm font-bold text-brutal-black py-1 uppercase tracking-wider">{l.label}</a>
          ))}
          <div className="flex gap-2 pt-3 border-t-2 border-brutal-black border-dashed">
            <button data-testid="header-mobile-login-btn" onClick={() => { setOpen(false); goLogin(); }} className="flex-1 font-mono text-xs font-bold uppercase tracking-wider border-[2.5px] border-brutal-black bg-white py-2.5 shadow-brutal-xs inline-flex items-center justify-center gap-1.5">
              <LogIn size={14} strokeWidth={3} />Entrar
            </button>
            <button data-testid="header-mobile-register-btn" onClick={() => { setOpen(false); goRegister(); }} className="flex-1 font-mono text-xs font-bold uppercase tracking-wider border-[2.5px] border-brutal-black bg-brutal-yellow py-2.5 shadow-brutal-sm inline-flex items-center justify-center gap-1.5">
              <Rocket size={14} strokeWidth={3} />Criar Conta
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
